import { render, staticRenderFns } from "./CopySocialImagesGallery.vue?vue&type=template&id=9ddd227a&scoped=true"
import script from "./CopySocialImagesGallery.vue?vue&type=script&lang=js"
export * from "./CopySocialImagesGallery.vue?vue&type=script&lang=js"
import style0 from "./CopySocialImagesGallery.vue?vue&type=style&index=0&id=9ddd227a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddd227a",
  null
  
)

export default component.exports